import { Info } from "@mui/icons-material";
import { Grid, IconButton, Popover, Typography } from "@mui/material";
import { BtnBaseButton, BtnClear, BtnSearch } from "components/Button/ButtonAll";
import DataGrid, { initRows, PaginationInterface } from "components/DataGrid";
import { DatePickerItem } from "components/Input/DatePicker/DatePickerItem";
import { MultipleSelectItem } from "components/Input/Select/MultipleSelectItem";
import { useEffect, useState } from "react";
import { FormProvider, useForm } from "react-hook-form"
import { FnAxios, FnDialog, formatNumber } from "utilities/utilities";
import DifferenceIcon from '@mui/icons-material/Difference';
import { useNavigate } from "react-router";
import { GetMenuPermission } from "utilities/SystemFunction";

export const ETicket = () => {

    const navigate = useNavigate();
    const AxiosFn = FnAxios();
    const DialogFn = FnDialog();

    const [isLoadingTable, setIsLoadingTable] = useState(false);
    const [arrTicket, setArrTicket] = useState([]);
    const [arrMuseum, setArrMuseum] = useState([]);
    const [sUpdateName, setSUpdateName] = useState(null);
    const [anchorEl, setAnchorEl] = useState(null);
    const [userType, setUserType] = useState(0);
    const [isPermission, setPermission] = useState<boolean>(false); // Permission

    const [dataRow, setDataRow] = useState<PaginationInterface>({
        ...initRows,
        sSortExpression: "dUpdate",
        sSortDirection: "asc"
    });
    const form = useForm({
        shouldFocusError: true,
        mode: "all",
        defaultValues: {} as any,
    });

    useEffect(() => {
        GetMenuPermission(AxiosFn, setPermission, DialogFn);
        GetDataTable(dataRow);
        getCheckEmpMuseum();
    }, [])


    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleViewInfo = (e) => {
        setSUpdateName(e.sUpdateBy);
    }

    const handleClose = () => {
        setAnchorEl(null);
    };

    const open = Boolean(anchorEl);

    const getCheckEmpMuseum = () => {
        DialogFn.BlockUI();
        AxiosFn.Get(`Ticket/GetCheckEmpMuseum`, { nMenuId: 20 }, (result) => {
            DialogFn.UnBlockUI();
            let objResult = result.objResult;
            setUserType(objResult.nUserTypeID)
            setArrMuseum(objResult.lstMuseum)
        });
    };

    const GetDataTable = (p: PaginationInterface = dataRow) => {
        const lstMuseum = form.getValues("sMuseumName")
        setIsLoadingTable(true);
        let param = {
            lstMuseum: lstMuseum ? lstMuseum.map(Number) : [],
            nTicketDate: form.getValues("dDate") ? form.getValues("dDate").valueOf() : null,
        }

        AxiosFn.Get(`ETicket/GetETicket`, param, (result) => {
            if (result.nStatusCode === 200) {

                let data = [...result.lstTicketSummary];
                setArrTicket(data);
                let ticket = data.slice(0, 10);
                let nNo = 1;

                ticket.forEach(item => {
                    item.nNo = nNo++;
                });
                setDataRow({
                    ...p,
                    arrRows: [...ticket],
                    nDataLength: data.length
                });
            }

            setIsLoadingTable(false);
        }, (err) => {
            DialogFn.Warning(err.Message);
            setIsLoadingTable(false);
        });
    }

    const UpdateTableImport = (p: PaginationInterface = dataRow) => {
        setIsLoadingTable(true);
        let nPageIndex = Math.max(0, p.nPageIndex - 1);
        let skip = p.nPageSize * nPageIndex;
        let take = skip + p.nPageSize;
        if (take > arrTicket.length) {
            take = arrTicket.length
        }

        let result = arrTicket.slice(skip, take);

        let nNo = 1;

        result.forEach(item => {
            item.nNo = nNo++;
        });
        setDataRow({
            ...p,
            nPageIndex: nPageIndex + 1,
            arrRows: [...result],
            nDataLength: [...arrTicket].length
        });

        setIsLoadingTable(false);
    }

    const onDelete = (value) => {
        DialogFn.Submit("คุณต้องการลบข้อมูลใช่หรือไม่ ?", () => {
            let objParam = {
                lstImport: value
            }

            AxiosFn.Post(`ETicket/DeleteImport`, objParam, (result) => {
                if (result.nStatusCode === 200) {
                    DialogFn.Success("ลบสำเร็จ", () => {
                        GetDataTable();
                    });
                }
            });
        });
    }

    const MuseumNameColumn: any = {
        field: 'sMuseum',
        headerName: 'ชื่อพิพิธภัณฑ์',
        headerAlign: 'center',
        align: 'left',
        flex: 3,
        sortable: false,
        isSort: false,
        collapse: false
    };

    const YearColumn: any = {
        field: 'sTicketDate',
        headerName: 'ประจำเดือน ปี',
        headerAlign: 'center',
        align: 'center',
        flex: 2,
        minWidth: 100,
        sortable: false,
        isSort: false,
        collapse: false
    };

    const TotalTicketColumn: any = {
        field: 'nTotalTicket',
        headerName: 'จำนวนบัตรทั้งหมด',
        headerAlign: 'center',
        align: 'center',
        flex: 1.5,
        sortable: false,
        isSort: false,
        collapse: false,
        renderCell: (item) => {
            return [
                <>
                    {formatNumber(item.row.nTotalTicket, 0)}
                </>
            ]
        }
    };

    const TotalAmountColumn: any = {
        field: 'nTotalAmount',
        headerName: 'จำนวนเงินทั้งหมด',
        headerAlign: 'center',
        align: 'center',
        flex: 1.5,
        sortable: false,
        isSort: false,
        collapse: false,
        renderCell: (item) => {
            return [
                formatNumber(item.row.nTotalAmount, 2)
            ]
        }
    };

    const TotalAudienceColumn: any = {
        field: 'nTotalAudience',
        headerName: 'จำนวนผู้เข้าชมทั้งหมด',
        headerAlign: 'center',
        align: 'center',
        flex: 1.5,
        sortable: false,
        isSort: false,
        collapse: false,
        renderCell: (item) => {
            return [
                formatNumber(item.row.nTotalAudience, 0)
            ]
        }
    };


    const UpdateColumn: any = {
        field: 'sUpdate',
        headerName: 'วันที่แก้ไขล่าสุด',
        headerAlign: 'center',
        align: 'center',
        flex: 2,
        minWidth: 100,
        sortable: false,
        isSort: false,
        collapse: false,
        renderCell: (item) => {
            return (
                <>
                    <Grid sx={{ mr: "4px" }}>
                        {item.row.sUpdate}
                    </Grid>
                    <IconButton size="small"
                        onClick={(e) => { handleClick(e); handleViewInfo(item.row); }}
                    >
                        <Info
                            style={{ color: "#6e130d", cursor: "pointer" }}
                        />
                    </IconButton>
                </>
            )
        }
    };

    let dataColumn = [MuseumNameColumn, YearColumn, TotalTicketColumn, TotalAmountColumn, TotalAudienceColumn, UpdateColumn] as any[];


    const onClear = () => {
        form.setValue("sMuseumName", null);
        form.setValue("dDate", null);
        UpdateTableImport(dataRow);
    }


    return (
        <FormProvider {...form}>
            <Grid container spacing={2} justifyContent={"space-between"} >
                <Grid item xs={2}>
                    <BtnBaseButton
                        txt="เพิ่มข้อมูลนำเข้า"
                        size={"medium"}
                        startIcon={<DifferenceIcon />}
                        IsRadius={false}
                        IsDisabled={!isPermission}
                        IsHidden={false}
                        onClick={() => {
                            navigate("/e-ticket/import")
                        }}
                        IsCircleWithOutText={false}
                        bgcolor="#33a64c"
                        bgcolorHover="#33a64c"
                        fontColor="#ffffff"
                        tooltipPlacement="bottom"
                        id="Btn-Preview-FollowUp"
                        className="Btn-Preview-FollowUp"
                    />
                </Grid>
                <Grid item xs={10}>
                    <Grid container spacing={2} justifyContent={"flex-end"}>
                        {userType !== 1 &&
                            <Grid item xs={12} sm={5.5}>
                                <MultipleSelectItem
                                    id={`sMuseumName`}
                                    name={`sMuseumName`}
                                    label={`ชื่อพิพิธภัณฑ์`}
                                    fullWidth
                                    disabled={false}
                                    options={arrMuseum}
                                    limitTag={1}
                                />
                            </Grid>
                        }
                        <Grid item xs={12} sm={4} md={3}>
                            <DatePickerItem
                                id={`dDate`}
                                name={`dDate`}
                                label={`ประจำเดือน-ปี`}
                                fullWidth
                                disabled={false}
                                IsMonthYearPicker
                                format="MMMM YYYY"
                            />
                        </Grid>
                        <Grid item xs={12} md={'auto'}>
                            <Grid container spacing={1} direction="row" justifyContent="center" alignItems="center" >
                                <Grid item>
                                    <BtnClear id={"btn-clear"} IsCircleWithOutText onClick={() => onClear()} />
                                </Grid>
                                <Grid item>
                                    <BtnSearch id={"btn-search"} IsCircleWithOutText onClick={() => { GetDataTable() }} />
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>

                <Grid item xs={12} >
                    <DataGrid
                        sTableID='importticket'
                        columns={dataColumn}
                        rows={dataRow}
                        onLoadData={(p) => { UpdateTableImport(p) }}
                        isHiddenToolHead
                        isLoading={isLoadingTable}
                        onDelete={(e) => onDelete(e)}
                    />
                </Grid>
            </Grid>

            {/* pop over UserUpdate */}
            <Popover
                id={`sUpdateName`}
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'center',
                    horizontal: 'right',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'left',
                }}
            >
                <Typography sx={{ p: 2 }}>{sUpdateName}</Typography>
            </Popover>
        </FormProvider>
    )
}